import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Divider from '@/components/UI/divider/Divider';
import styles from './HouseVideo.module.scss';
type HouseVideoProps = {
  videoId: string;
};
const HouseVideo: FC<HouseVideoProps> = ({
  videoId
}) => {
  const url = `https://www.aparat.com/video/video/embed/videohash/${videoId}/vt/frame`;
  return videoId && <Box className={styles['house-video']} component={'section'}>
        <Typography variant="bodyL_Bold" color="neutral_800" component="h2">
          ویدیو اقامتگاه
        </Typography>
        <iframe className={styles['house-video-section']} src={url} allowFullScreen={true}></iframe>
        <Divider orientation="horizontal" />
      </Box>;
};
export default HouseVideo;